export default __webpack_public_path__ + "fdc0c1839d39be3d1b7db63cc048a711.png";